export type UserMediaConstraints = {
    audio?: boolean;
    video?: {
        facingMode?:string;
    };
}

export class UserMediaContainer extends Phaser.GameObjects.Container
{
    private _constraints:UserMediaConstraints;
    private _video?:Phaser.GameObjects.Video;
    public get video():Phaser.GameObjects.Video { return this._video; };
    private _stream?:MediaStream;
    private _status: "loading" | "success" | "failed" | "stopped" = "loading";
    public get status(): "loading" | "success" | "failed" | "stopped"  {
        return this._status;
    }

    public readonly ON_MEDIA_STREAM_STARTED = "onMediaStreamStarted";
    public readonly ON_MEDIA_STREAM_FAILED = "onMediaStreamFailed";

    constructor(scene: Phaser.Scene, x?: number, y?: number, constraints?:UserMediaConstraints)
    {
        super(scene, x, y, []);
        this._constraints = constraints;
        if(this._constraints && navigator.mediaDevices)
        {
            console.log("Attempting to getUserMedia");
            navigator.mediaDevices.getUserMedia(constraints).then((stream:MediaStream)=>this.onGetUserMediaSuccess(stream)).catch((reason:any)=>this.onGetUserMediaError(reason));
        }
        else
        {
            console.log("Lacking constraints or mediaDevices. Is this served via a secure location (HTTPS or localhost)?");
            console.log(this._constraints);
            console.log(navigator.mediaDevices);
            this._status = "failed";
        }
		scene.events.once(Phaser.Scenes.Events.SHUTDOWN, this.stopStream, this);
    }

    private onGetUserMediaSuccess(stream:MediaStream)
    {
        this._stream = stream;
		if(!this.scene) {
			this.stopStream();
			return;
		}
        console.log("onGetUserMediaSuccess");
        this._video = this.scene.add.video(0, 0);
        this.add(this._video);
        this._video.loadMediaStream((<any>stream), "onloadeddata", !this._constraints.audio);
        this._video.play();
        this._status = "success";
        this.emit(this.ON_MEDIA_STREAM_STARTED);
        console.log(this._video);
    }

    private onGetUserMediaError(reason:any)
    {
        console.log("onGetUserMediaError");
        console.log(reason);
        this._status = "failed";
        this.emit(this.ON_MEDIA_STREAM_FAILED);
    }

    public getStreamSize():Phaser.Math.Vector2
    {
        if(this._stream && this._constraints.video)
        {
            const videoTracks = this._stream.getVideoTracks();
            if(videoTracks.length > 0)
            {
                const settings = videoTracks[0].getSettings();
                return new Phaser.Math.Vector2(settings.width, settings.height);
            }
        }
        return new Phaser.Math.Vector2(0, 0);
    }

    public snapshot(key:string, width?:number, height?:number):Phaser.Textures.CanvasTexture|null
    {
        if(this._video)
        {   
            const snapshotWidth = Math.ceil(width ? width + 20:this._video.width); //might not be best solution, manually adding width since this is only place snapshot happens
            const snapshotHeight = Math.ceil(height?height:this._video.height);
            const canvasTexture = this._video.snapshot(snapshotWidth, snapshotHeight);
            this._video.saveSnapshotTexture(key);
            console.log("Snapshotted texture");
            console.log(canvasTexture);
            console.log(this.scene.game.textures.get(key));
            return canvasTexture;
        }
        console.log("no video?");
        return null;
    }

	public stopStream(): void {
		if(this._stream)
		{
			this._stream.getTracks().forEach(track=>{
				if(track.readyState == 'live')
				{
					track.stop();
				}
			});
			this._stream = null;
			if(this._video) this._video.destroy();
			this._video = null;
			this._status = "stopped";
		}
	}
}